import React from "react";
import "../../styles/dayStyles/Day12.css"

export default function Day12() {
    return (
        <div className="day-container container-color12">
            Coming Soon!
        </div>
    )
}